export const getPage = state => state.integrations;

export const getLoading = state => state.integrations.loading;

export const getError = state => state.integrations.error;

export const getConfiguration = state => state.integrations.configuration;
